// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = module.exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".container[data-v-7c71e45e] {\n  padding: 20px;\n  overflow-y: auto;\n  height: calc(100vh - 200px);\n  background-color: white;\n}\n.formItemInput[data-v-7c71e45e] {\n  width: 300px;\n  margin-right: 20px;\n}\n.itemPrompt[data-v-7c71e45e] {\n  margin-left: 40px;\n}", ""]);
